<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container pa-0 fluid grid-list-md class="patient-wnd">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm12 pa-0>
                <div class="sub-window">
                    <v-app-bar color="grey lighten-5" flat fixed>
                        <v-app-bar-nav-icon class="hidden-md-and-up" @click="drawer = !drawer"></v-app-bar-nav-icon>

                        <router-link to="/">
                            <img height="55" :src="navMainLogo" />
                        </router-link>

                        <v-toolbar-title class="hidden-sm-and-down">
                            <div class="sip-blue title">&nbsp; {{ userName }}</div>
                        </v-toolbar-title>

                        <v-toolbar-title class="hidden-md-and-up">
                            <div class="sip-blue subtitle-1">&nbsp; {{ userName }}</div>
                        </v-toolbar-title>

                        <v-divider class="mx-4" inset vertical></v-divider>

                        <v-spacer></v-spacer>

                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                text
                                class="text-none cyan--text text--darken-3"
                                @click="onNewConsult"
                            >
                                <v-icon color="cyan darken-3">mdi-clipboard-pulse-outline</v-icon>&nbsp; Nueva Consulta
                            </v-btn>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="text-none cyan--text text--darken-3"
                                        v-on="on"
                                    >
                                        <v-icon color="cyan darken-3">mdi-chart-line</v-icon>&nbsp; Información Clínica
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="onGrowthCharts">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-chart-multiple</v-icon>&nbsp; Gráficas de crecimiento...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="onVaccination">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-eyedropper-variant</v-icon>&nbsp; Vacunas...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="onExportClinicalHistory">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-clipboard-text-outline</v-icon>&nbsp; Generar historial clínico...
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="text-none cyan--text text--darken-3"
                                        v-on="on"
                                    >
                                        <v-icon color="cyan darken-3">mdi-calendar</v-icon>&nbsp; Citas
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="onGrowthCharts">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-calendar-blank</v-icon>&nbsp; Agendar cita...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="onVaccination">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-calendar-search</v-icon>&nbsp; Próximas citas...
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        class="text-none cyan--text text--darken-3"
                                        v-on="on"
                                    >
                                        <v-icon color="cyan darken-3">mdi-file-multiple-outline</v-icon>&nbsp; Archivos
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item @click="onImageFiles">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-image-outline</v-icon>&nbsp; Imágenes...
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="onDocumentFiles">
                                        <v-list-item-title>
                                            <v-icon color="cyan darken-3">mdi-file-document-outline</v-icon>&nbsp; Documentos...
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-toolbar-items>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-toolbar-title class="cyan--text text--darken-3">{{ patientName }}</v-toolbar-title>&nbsp;
                        <!-- <v-avatar :tile="true" :size="patientPhotoSize" color="grey lighten-4">
                                <img :src="patientPhoto" />
                        </v-avatar>-->
                        <img :height="patientPhotoSize" :src="patientPhoto" />

                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn small text :disabled="bEdit" @click="onClose" v-on="on">
                                    <v-icon color="red">close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar Paciente</span>
                        </v-tooltip>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-list-item @click="onNewConsult">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-account-card-details</v-icon>&nbsp; Información General
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>
                                <v-list-item @click="onCarDetails">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-car</v-icon>&nbsp; Ver detalles de
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item @click="onDeleteCar">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-delete</v-icon>&nbsp; Borrar
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item @click="onNewCar">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-home-import-outline</v-icon>&nbsp; Importar Automóvil...
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>

                                <v-list-item @click="onEditSale">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-pencil</v-icon>&nbsp; Editar Venta
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="onDeleteSale">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-trash-can</v-icon>&nbsp; Borrar Venta
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="onCancel">
                                    <v-list-item-title>
                                        <v-icon color="blue darken-2">mdi-cancel</v-icon>&nbsp; Cancelar Edición
                                    </v-list-item-title>
                                </v-list-item>

                                <v-divider></v-divider>

                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">close</v-icon>&nbsp; Cerrar Paciente
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-app-bar>

                    <!-- Container para todos los campos de la ventana: -->
                    <v-container grid-list-xs fluid>
                        <v-layout row>
                            <v-flex xs12>
                                <clinical-history :patient="this.patient"></clinical-history>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <consult :patient="this.patient"></consult>
                            </v-flex>
                        </v-layout>

                        <v-layout row>
                            <v-flex xs12>
                                <consult-history :patient="this.patient"></consult-history>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>

        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ClinicalHistory from '@/components/ClinicalHistory';
import Consult from '@/components/Consult';
import ConsultHistory from '@/components/ConsultHistory';

export default {
    name: 'Client',
    data() {
        return {
            drawer: false,
            bEdit: false,
            item: 0,

            patientName: 'Julio Gómez Rodríguez',
            patientPhoto: require('@/assets/patientphoto.jpg'),

            bMenuBirthDay: false,
            age: '',

            patient: {
                curp: '',
                lastName1: '',
                lastName2: '',
                name: '',
                pseudonym: '',
                sex: 0,
                civilState: 0,
                spouseLastName: '',
                birthDay: '',
                citizenship: '',
                religion: '',
                ocupation: '',
                education: '',
                notes: '',
                familyHistory: '',
                pathologicalHistory: '',
                nonPathologicalHistory: '',
                allergies: '',
                gynecoObstetricHistory: '',
                activeDx: '',
                activeTx: '',
                bloodTypeID: 1,
                organDonor: true,
                socialSecurity: '',
                privateSecurity: '',
                referedFrom: '',
                visualDisability: false,
                hearingImpairment: false,
                mentalDisability: false,
                motorDisability: false,
                otherDisability: '',
                address: {
                    street: '',
                    number: '',
                    colonia: '',
                    cp: '',
                    municipio: '',
                    state: '',
                    country: ''
                },
                phone1: '',
                phone2: '',
                mobile: '',
                email: '',
                family: [
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    },
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    },
                    {
                        lastName1: '',
                        lastName2: '',
                        name: '',
                        phone: '',
                        relationship: ''
                    }
                ],

                headers: [
                    {
                        text: 'Marca',
                        align: 'left',
                        sortable: true,
                        value: 'marca',
                        width: '20%'
                    },
                    { text: 'Submarca', value: 'submarca', width: '20%' },
                    { text: 'Modelo', value: 'modelo', width: '10%' },
                    { text: 'Placas', value: 'placas', width: '10%' },
                    { text: 'Número de Motor', value: 'motor', width: '20%' },
                    { text: 'Número de Serie', value: 'serie', width: '20%' }
                ],
                headerCars: [
                    {
                        text: 'Marca',
                        value: 'brand',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    },
                    {
                        text: 'Submarca',
                        value: 'subBrand',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    },

                    {
                        text: 'Modelo',
                        value: 'model',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    },
                    {
                        text: 'Placas',
                        value: 'plates',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    },
                    {
                        text: 'Número de Motor',
                        value: 'motor',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    },
                    {
                        text: 'Número de Serie',
                        value: 'series',
                        align: 'start',
                        sortable: true,
                        divider: true,
                        width: '16.66%'
                    }
                ],

                headerProducts: [
                    {
                        text: 'Código',
                        value: 'code',
                        align: 'start',
                        sortable: false,
                        divider: true,
                        width: '15%'
                    },
                    {
                        text: 'Cantidad',
                        value: 'quantity',
                        align: 'end',
                        sortable: false,
                        divider: true,
                        width: '5%'
                    },

                    {
                        text: 'Descripción',
                        value: 'description',
                        align: 'start',
                        sortable: false,
                        divider: true,
                        width: '35%'
                    },
                    {
                        text: 'Estado',
                        value: 'status',
                        align: 'start',
                        sortable: false,
                        divider: true,
                        width: '15%'
                    },
                    {
                        text: 'Subtotal',
                        value: 'subtotal',
                        align: 'end',
                        sortable: false,
                        divider: true,
                        width: '15%'
                    },
                    {
                        text: 'IVA',
                        value: 'iva',
                        align: 'end',
                        sortable: false,
                        divider: true,
                        width: '15%'
                    }
                ]
            },

            selectedCar: 0,
            selectedSale: 0,

            selectedProduct: -1,
            selectedProductOfInterest: -1
        };
    },
    components: {
        ClinicalHistory,
        Consult,
        ConsultHistory
    },
    beforeRouteUpdate(to, from, next) {
        console.log('beforeRouteUpdate');

        next();
    },
    created() {},
    methods: {
        ...mapActions([
            'initSaleFields',
            'getClientData',
            'getClientCars',
            'updateClientCarID',
            'updateSaleID'
            //'setNewClient'
        ]),
        dataTableClick() {
            console.log('dataTableClick');
        },
        onNewConsult() {},

        onGrowthCharts() {},

        onVaccination() {},

        onExportClinicalHistory() {},

        onImageFiles() {},

        onDocumentFiles() {},

        onCarDetails() {
            //console.log('onCarDetails');
            //this.$router.push('/car-info');
            this.$store.dispatch('updateShowClientCarInfoDlg', true);
        },
        onNewCar() {
            console.log('onNewCar');
        },
        onDeleteCar() {
            console.log('onDeleteCar');
        },
        onNewSaleForSelectedCar() {
            console.log('onNewSaleForSelectedCar');
        },
        onNewCarSale() {
            this.$store.dispatch('updateShowNewCarSaleDlg', true);
        },
        onEditSale() {
            console.log('onEditSale');
        },
        onDeleteSale() {
            console.log('onDeleteSale');
        },
        onCancel() {
            console.log('onCancel');
        },
        prueba() {
            console.log('click on row');
        },
        onClickCar(id) {
            //console.log('Click on Auto');
            this.onAuto(id);
        },
        onDblClickCar(id) {
            //console.log("Double Click on Auto");
            //this.onAuto(id); Esto no es necesario, ya que antes del doble click siempre se detecta un cick.
            //Se abre la ventana CarInfo:
            this.onCarDetails();
        },
        onAuto(id) {
            //console.log('OnAuto', id);
            //console.log('SelectedCar = ', + this.selectedCar);

            //Se actualizan el ID del coche y el historial de ventas del coche:
            this.updateClientCarID(id);
        },

        onSale(id) {
            console.log('onSale ' + id);
            //Se actualizan el ID y la información de la venta:
            this.updateSaleID(id);
        },
        onProduct(id) {
            console.log('onProduct ' + id);
        },
        onProductOfInterest(id) {
            console.log('onProductOfInterest ' + id);
        },

        onClose() {
            this.$router.push('/');
        },
        onSelectSaleType() {
            if (this.selectedSaleType === undefined) {
                this.$store.dispatch('emptySaleSubTypes');
            } else {
                this.$store.dispatch(
                    'getSaleSubTypes',
                    this.selectedSaleType.id
                );
            }
        },
        onSelectSaleSubType() {
            console.log('SaleSubType = ', this.selectedSaleSubType);
        },
        onNewConsult() {},
        onEditConsult() {},
        onCancel() {},
        onSaveConsult() {},
        onDeleteConsult() {}
    },
    computed: {
        ...mapGetters(['clientID', 'waitCursor', 'navMainLogo', 'userName']),
        saleTitle() {
            var strTitle;
            if (this.sale.saleKind === 1) {
                //strTitle = "Venta " + this.sale.
            }
            return strTitle;
        },

        showClientInfoDlg: {
            get() {
                return this.$store.getters.showClientInfoDlg;
            },
            set(showClientInfoDlg) {
                this.$store.dispatch(
                    'updateShowClientInfoDlg',
                    showClientInfoDlg
                );
            }
        },
        showClientCarInfoDlg: {
            get() {
                return this.$store.getters.showClientCarInfoDlg;
            },
            set(showClientCarInfoDlg) {
                this.$store.dispatch(
                    'updateShowClientCarInfoDlg',
                    showClientCarInfoDlg
                );
            }
        },
        showNewCarSaleDlg: {
            get() {
                return this.$store.getters.showNewCarSaleDlg;
            },
            set(showNewCarSaleDlg) {
                this.$store.dispatch(
                    'updateShowNewCarSaleDlg',
                    showNewCarSaleDlg
                );
            }
        },

        photoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '50';
            } else if (this.$vuetify.breakpoint.md) {
                height = '65';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },

        patientPhotoSize() {
            var size;
            if (this.$vuetify.breakpoint.xs) {
                size = '56';
            } else if (this.$vuetify.breakpoint.sm) {
                size = '56';
            } else if (this.$vuetify.breakpoint.md) {
                size = '63';
            } else if (this.$vuetify.breakpoint.lg) {
                size = '64';
            } else {
                size = '66';
            }
            return size;
        },

        carsTableHeight() {
            var height = '100px';
            if (this.$vuetify.breakpoint.xs) {
                height = '130px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '120px';
            } else if (this.$vuetify.breakpoint.md) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '100px';
            } else if (this.$vuetify.breakpoint.xl) {
                height = '100px';
            }
            return height;
        },
        productsTableHeight() {
            var height = '100px';
            if (this.$vuetify.breakpoint.xs) {
                height = '130px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '130px';
            } else if (this.$vuetify.breakpoint.md) {
                height = '110px';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '135px';
            } else if (this.$vuetify.breakpoint.xl) {
                height = '135px';
            }
            return height;
        },

        modalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '85%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        },

        newCarWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '65%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '60%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.patient-wnd {
    background: url('../assets/background1.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}
.sub-window {
    /* background-color: #eeeeee; */
    /*grey lighten-3 */
    background: rgba(224, 224, 224, 0.5);
}
.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
.my-car-table {
    width: 100%;
}

.my-product-list {
    /* font-size: 11px; */
    /* font-weight: bold; */

    background-color: #e0e0e0;
}

.sip-blue {
    color: #283593;
    /* indigo darken-3 */
}

/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>